<script>
  import { stringifyStyle, calcPxNum } from './utils'
  export let direction = undefined // default: row
  export let reverse = false
  export let align = undefined // default: flex-start
  export let xAlign = undefined // default: stretch
  export let expand = undefined // default: 0
  export let shrink = undefined
  export let basis = undefined
  export let width = undefined
  export let height = undefined
  export let minWidth = undefined
  export let maxWidth = undefined
  export let minHeight = undefined
  export let maxHeight = undefined
  export let backgroundColor = undefined
  export let wrap = false
  export let overflow = undefined
  export let overflowX = undefined
  export let overflowY = undefined

  $: style = {
    'display': 'flex',
    'flex-wrap': wrap ? 'wrap' : null, // null means default nowrap
    'flex-direction': reverse ? direction+'-reverse' : direction,
    'justify-content': align,
    'align-items': xAlign,
    'flex-grow': expand, // or flex:expand
    'flex-shrink': shrink,
    'flex-basis': basis,
    'width': calcPxNum(width),
    'height': calcPxNum(height),
    'min-width': calcPxNum(minWidth),
    'max-width': calcPxNum(maxWidth),
    'min-height': calcPxNum(minHeight),
    'max-height': calcPxNum(maxHeight),
    'background-color': backgroundColor,
    'overflow': overflow,
    'overflow-x': overflowX,
    'overflow-y': overflowY,
  }
</script>

<div style={stringifyStyle(style)}>
  <slot></slot>
</div>